module.exports = __webpack_public_path__ + "img/tiger-machine-box.9399a730.svg";